import ActionTypePrincipal from "../../ActionTypePrincipal";

export default class ActionCerrarSesion extends ActionTypePrincipal {
    ejecutar(estado, nuevoEstado){
        nuevoEstado.banderaCerrandoSesion = true; 
        return nuevoEstado;
    }
}
